import emitter from 'tiny-emitter/instance';

export const bus = {
  $on: (...args) => emitter.on(...args),
  $once: (...args) => emitter.once(...args),
  $off: (...args) => emitter.off(...args),
  $emit: (...args) => emitter.emit(...args),
};

export const busEvents = {
  selectModule: 'selectModule',
  orderUpdated: 'orderUpdated',
  orderUpdateError: 'orderUpdateError',
  pdfLoaded: 'pdfLoaded',
  refreshCredits: 'refreshCredits',
};
